export default "__VITE_ASSET__DwkLiB6P__"